import { BTText } from "@btnet/core-components";
import { useCostInboxMigrationOptInPostV2 } from "@btnet/services-btnet/handlers/cost-inbox-migration/cost-inbox-migration";
import { CostInboxMigrationChoice } from "@btnet/services-btnet/handlers/models/costInboxMigrationChoice";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTModal } from "commonComponents/btWrappers/BTModal/BTModal";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";

import "./CostInboxOptInModal.less";

export interface ICostInboxOptInModalProps {
    onClose: () => void;
    onOptInComplete: () => void;
}

export const CostInboxOptInModal: React.FC<ICostInboxOptInModalProps> = ({
    onClose,
    onOptInComplete,
}) => {
    const { mutate: optIn, isLoading: isSubmitting } = useCostInboxMigrationOptInPostV2({
        mutation: {
            onSuccess: (response) => {
                if (response.data.success) {
                    onOptInComplete();
                }
            },
        },
    });

    const handleSwitch = () => {
        optIn({ data: { choice: CostInboxMigrationChoice.KeepReceipts } });
    };

    return (
        <BTModal
            data-testid="costInboxOptInModal"
            visible
            centered
            width="640px"
            removeBodyPadding
            beforeClose={onClose}
            title="Switch to Bills"
        >
            <BTRow className="padding-right-md padding-left-md padding-bottom-md">
                <BTCol span={24} className="margin-bottom-sm">
                    <BTText size="normal-lg">Before you switch, review these changes:</BTText>
                </BTCol>
                <BTCol span={24}>
                    <ul className="CostInboxOptInModal margin-bottom-md padding-left-lg">
                        <li>
                            <BTText size="normal-lg">
                                <b>
                                    This affects your <u>entire account.</u>
                                </b>
                                <br />
                                All new costs for your organization will route through Bills.
                            </BTText>
                        </li>
                        <li>
                            <BTText size="normal-lg">
                                <b>New records will go to Bills Inbox only.</b>
                                <br />
                                New incoming costs will appear in the Inbox tab on the Bills page.
                                New records will no longer be added to Cost Inbox.
                            </BTText>
                        </li>
                        <li>
                            <BTText size="normal-lg">
                                <b>This is a one-way switch.</b>
                                <br />
                                After you switch, you won’t be able to return to processing new
                                costs through the Cost Inbox.
                            </BTText>
                        </li>
                        <li>
                            <BTText size="normal-lg">
                                <b>Your existing records will remain available.</b>
                                <br />
                                Historical records in Cost Inbox will still be accessible.
                            </BTText>
                        </li>
                    </ul>
                    <BTRow justify="end">
                        <BTButton
                            data-testid="optInGoBackButton"
                            type="secondary"
                            className="margin-right-sm"
                            onClick={onClose}
                        >
                            Keep exploring
                        </BTButton>
                        <BTButton
                            data-testid="optInSwitchButton"
                            loading={isSubmitting}
                            onClick={handleSwitch}
                        >
                            Switch to Bills
                        </BTButton>
                    </BTRow>
                </BTCol>
            </BTRow>
        </BTModal>
    );
};
